/**
 * 通用工具方法
 */
import { ElMessage } from 'element-plus'
import { isObject } from '@/utils/is/index'
import { IsHidden } from '@/enum'
import qs from 'qs'

// import { FormItem } from "@/components/Form/interface/index.model";
/**
 * @description 获取localStorage
 * @param {String} key Storage名称
 * @return string
 */
export function localGet(key: string) {
  const value = window.localStorage.getItem(key)
  try {
    return JSON.parse(window.localStorage.getItem(key) as string)
  } catch (error) {
    return value
  }
}

/**
 * @description 存储localStorage
 * @param {String} key Storage名称
 * @param {Any} value Storage值
 * @return void
 */
export function localSet(key: string, value: any) {
  window.localStorage.setItem(key, JSON.stringify(value))
}

/**
 * @description 清除localStorage
 * @param {String} key Storage名称
 * @return void
 */
export function localRemove(key: string) {
  window.localStorage.removeItem(key)
}

/**
 * @description 清除所有localStorage
 * @return void
 */
export function localClear() {
  window.localStorage.clear()
}

/**
 * @description 对象数组深克隆
 * @param {Object} obj 源对象
 * @return object
 */
export function deepCopy<T>(obj: any): T {
  let newObj: any
  try {
    newObj = obj.push ? [] : {}
  } catch (error) {
    newObj = {}
  }
  for (let attr in obj) {
    if (typeof obj[attr] === 'object') {
      newObj[attr] = deepCopy(obj[attr])
    } else {
      newObj[attr] = obj[attr]
    }
  }
  return newObj
}

/**
 * @description 生成随机数
 * @param {Number} min 最小值
 * @param {Number} max 最大值
 * @return number
 */
export function randomNum(min: number, max: number): number {
  let num = Math.floor(Math.random() * (min - max) + max)
  return num
}

/**
 * @description 获取浏览器默认语言
 * @return string
 */
export function getBrowserLang() {
  let browserLang = navigator.language ? navigator.language : navigator.browserLanguage
  let defaultBrowserLang = ''
  if (
    browserLang.toLowerCase() === 'cn' ||
    browserLang.toLowerCase() === 'zh' ||
    browserLang.toLowerCase() === 'zh-cn'
  ) {
    defaultBrowserLang = 'zh'
  } else {
    defaultBrowserLang = 'en'
  }
  return defaultBrowserLang
}

/**
 * @description 递归查询当前路由所对应的路由
 * @param {Array} menuList 菜单列表
 * @param {String} path 当前地址
 * @return array
 */
export function getTabPane<T, U>(menuList: any[], path: U): T {
  let result: any
  for (let item of menuList || []) {
    if (item.path === path) result = item
    const res = getTabPane(item.children, path)
    if (res) result = res
  }
  return result
}

/**
 * 经纬度格式转换
 * @param lat 纬度
 * @param lng  经度
 * @param fmt1 当前格式 DDD
 * @param fmt2 需要转换的格式 DMS
 * @returns
 */
export function LatlngCnvTool(lat: number | string, lng: number | string, fmt1: string = 'DDD', fmt2: string = 'DMS') {
  let lngFormat = ''
  let latFormat = ''
  let latSymbol = 'N'
  let lngSymbol = 'E'
  if (typeof lat === 'string') {
    lat = Number(lat)
    if (lat < 0) latSymbol = 'S'
    if (lat === 0) latSymbol = ''
    lat = Math.abs(lat)
  }
  if (typeof lng === 'string') {
    lng = Number(lng)
    if (lng < 0) lngSymbol = 'W'
    if (lng === 0) lngSymbol = ''
    lng = Math.abs(lng)
  }
  //按格式进行转化
  if (fmt1 == 'DDD') {
    if (fmt2 == 'DMS') {
      lngFormat = DDDToDMS(lng)
      latFormat = DDDToDMS(lat)
    }
  } else {
    return ''
  }
  return latFormat + latSymbol + ',' + lngFormat + lngSymbol
}
//DDD转DMS °、′、″ 这里为用 '代替了′ " 代替 ″ 8°14'2.8428"
export function DDDToDMS(_data: number) {
  let value = parseFloat(_data + '')
  let _d = Math.floor(value) //度
  let _m = Math.floor((value - _d) * 60) //分
  //let _s = Math.round((value - _d) * 3600 % 60);//秒 保留整数
  let _s = parseFloat((((value - _d) * 3600) % 60).toString()).toFixed(2) //精确小数点后面两位
  return _d + '°' + _m + '′' + _s + '"'
}

/**下载base64文件 */
export function downloadBase64Img(dataURL: string, fileName: string) {
  const imgUrl = `${dataURL}`
  // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
  if (window.navigator.msSaveOrOpenBlob) {
    const bstr = atob(imgUrl.split(',')[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    const blob = new Blob([u8arr])
    window.navigator.msSaveOrOpenBlob(blob, fileName + '.' + 'png')
  } else {
    // 这里就按照chrome等新版浏览器来处理
    const a = document.createElement('a')
    a.href = imgUrl
    a.setAttribute('download', fileName + '.' + 'png')
    a.click()
  }
}

/**功能暂未开放 */
export function TodoFunc() {
  ElMessage.warning('该功能暂未开放')
}

/**
 * 将对象转换成字符串类型
 * @param obj : 需要转换的对象
 * @param splitStr : 分隔符 默认 ";"
 * @param needKey : 是否需要展示key 默认 true
 * @returns 返回一个字符串
 */
export function formatObject(obj: { [key: string]: any }, splitStr: string = ';', needKey: boolean = true): string {
  if (!isObject(obj)) return ''
  return Object.keys(obj)
    .map((key) => {
      // @ts-ignore
      return (needKey ? key + '=' : '') + obj[key]
    })
    .join(splitStr)
}

/**将完整的对象转化为部分所需对象
 * 注意！ 该方法仅适用于 详情表单的内容渲染
 * @param full 完整的请求过来的详情参数对象
 * @param formItem 当前构成详情表单的数组
 * @param T 详情参数对象的类型泛型
 * */
export function changeFullToNeed<T>(full: T, formItem: any[]) {
  // 遍历表单组件，获取所需要的键名组成对象，生成新的数组
  const needArr = formItem.map((item) => {
    /**详情表单对象 */
    const need = {}
    const has = Reflect.has(full as object, item.prop)
    // 如果该属性在表单内存在，放入所需对象中
    if (has) {
      const value = Reflect.get(full as object, item.prop)
      Reflect.set(need, 'value', value)
      Reflect.set(need, 'prop', item.prop)
    }
    return need
  })

  return needArr as { prop: string; value: any }[]
}

/**递归处理 hidden 字段(由于后端字段值统一为 "1" true ，"2" false) */
interface HiddenDataLList<T> {
  hidden: boolean | number
  children: T[]
}
export function changeHiddenToBoolean<T extends HiddenDataLList<T>>(data: Array<T>) {
  return data.map((item) => {
    item.hidden = item.hidden == IsHidden.Display ? true : false

    if (item.children && item.children.length > 0) {
      item.children = changeHiddenToBoolean<T>(item.children)
    }

    return item
  })
}

/**剔除对应数组元素，通过prop
 * @param {list} list 表单元素列
 * @param {props} props 表单元素的prop标识数组
 */
export const removeByProps = <T extends { prop?: string }>(list: T[], props: string[]) =>
  list.filter((item) => !props.includes(item.prop ?? ''))

/**插入对应数组元素，通过prop
 * @param {list} list 表单元素列
 * @param {props} props 需要插入位置表单元素的prop标识
 * @param {insertItems} insertItems 插入的表单元素列
 */
export const insertAfterProp = <T extends { prop?: string }>(list: T[], afterProp: string, insertItems: T[]) => {
  const index = list.findIndex((item) => item.prop === afterProp)
  if (index === -1) return list

  // 防止重复插入
  const insertProps = new Set(insertItems.map((i) => i.prop))
  const cleaned = list.filter((i) => !insertProps.has(i.prop))

  return [...cleaned.slice(0, index + 1), ...insertItems, ...cleaned.slice(index + 1)]
}

/**删除校验规则，通过key
 * @param {target} target 基础规则
 * @param {aimAt} aimAt 目标规则
 */
export const removeRuleByKey = <T>(target: T, aimAt: T) => {
  // 目标校验规则 ===》 存储规则key，便于后续维护删除
  const keys: string[] = []
  for (const i in aimAt) {
    keys.push(i as string)
  }

  // 基础规则，添加规则，不然通过key删除对应规则
  keys.forEach((key) => {
    Reflect.deleteProperty(target as object, key)
  })

  return target
}
/**
 * 时间戳格式化函数
 * @param timestamp 时间戳（支持秒级和毫秒级）
 * @param format 格式化格式，默认 'YYYY-MM-DD HH:mm:ss'
 * @returns 格式化后的时间字符串
 */
export function formatTimestamp(
  timestamp: number | string | null | undefined,
  format: string = 'YYYY-MM-DD HH:mm:ss'
): string {
  // 如果为空或0，返回"-"
  if (!timestamp || timestamp === 0 || timestamp === '0') {
    return '-'
  }

  try {
    // 转换为数字
    let timeNum: number
    if (typeof timestamp === 'string') {
      timeNum = parseFloat(timestamp)
      // 如果转换失败，尝试去掉非数字字符
      if (isNaN(timeNum)) {
        timeNum = parseInt(timestamp.replace(/[^\d]/g, ''))
      }
    } else {
      timeNum = timestamp
    }

    // 检查是否为有效数字
    if (isNaN(timeNum) || timeNum <= 0) {
      return '-'
    }

    // 判断是秒级还是毫秒级时间戳
    let date: Date
    if (timeNum < 10000000000) {
      date = new Date(timeNum * 1000)
    } else {
      date = new Date(timeNum)
    }

    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      return '-'
    }

    // 根据格式进行格式化
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    // 替换格式字符串
    return format
      .replace('YYYY', String(year))
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds)
  } catch (error) {
    console.error('时间格式化错误:', error, timestamp)
    return '-'
  }
}

/**
 * 时间戳格式化函数
 * @param timestamp 时间戳
 * @returns 格式化后的字符串，如：2024-01-01 12:30:45
 */
export function formatTime(timestamp: number | string | null | undefined): string {
  return formatTimestamp(timestamp, 'YYYY-MM-DD HH:mm:ss')
}

/**
 * 时间戳格式化函数
 * @param timestamp 时间戳
 * @returns 只返回日期部分，如：2024-01-01
 */
export function formatDate(timestamp: number | string | null | undefined): string {
  return formatTimestamp(timestamp, 'YYYY-MM-DD')
}

/**安全序列化JSON数据格式 */
export function safeStringifyQuery(q: object) {
  // qs 对 null/undefined 的处理在不同版本可能不一致，自己兜底最稳
  return qs.stringify(q ?? {}, { skipNulls: true })
}

/**  */
